// frontend/src/exercises/NonWords.js
import React, { useState, useContext, useEffect } from 'react';
import Planet from "../../components/Planet";
import Header from "../../components/Header";
import StarBackground from "../../components/StarBackground";
import Character from "../../components/Character";
import Controls from "../../components/Controls";
import '../../styles/Intro.css';
import config from './nonWordsConfig';
import {getTranslation} from "../../config/translations";
import { AppContext } from "../../contexts/AppContext";
import {useNavigate} from "react-router-dom";

export default function NonWordsTutorial() {
    const navigate = useNavigate();
    const [wordIndex, setWordIndex] = useState(0);
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('selectedLanguage') || 'it');
    const [step, setStep] = useState(1);
    const [message, setMessage] = useState('');
    const [isRecording, setIsRecording] = useState(false);
    const translations = getTranslation(currentLanguage);

    // Dynamically get words based on currentLanguage
    const words = translations.exerciseWords.nonWords[1] || [];

    const currentWord = words[wordIndex];
    const isLast = wordIndex === words.length - 1;

    const { enableText, enableAudio, setEnableText, setEnableAudio } = useContext(AppContext);

    // Listen for language changes
    useEffect(() => {
        const handleLanguageChange = () => {
            const newLanguage = localStorage.getItem('selectedLanguage') || 'it';
            if (newLanguage !== currentLanguage) {
                setCurrentLanguage(newLanguage);
                // Reset wordIndex when language changes to start the exercise from the beginning for the new language
                setWordIndex(0);
            }
        };

        const interval = setInterval(handleLanguageChange, 500);

        return () => clearInterval(interval);
    }, [currentLanguage]);

    useEffect(() => {
        if (step === 1) {
            setMessage("Facciamo un esempio per scaldarci! Quando INIZIA il gioco, la persona che è con te cliccherà il tasto giallo play e ascolterai una parola.");
        } else if (step === 2) {
            setMessage("Ora si illuminerà il microfono di rosso e potrai parlare. Ripeti dopo di me: “" + currentWord + "”");

            const timer = setTimeout(() => setStep(3), 10000);
            return () => clearTimeout(timer);
        } else if (step === 3) {
            setMessage("Premi il tasto verde per confermare.");
        } else if (step === 4) {
            setMessage("Perfetto, ora prova tu!");
            const timer = setTimeout(() => {
                window.location.href = `/exercise/nonWords/test`;
            }, 1000);
            return () => clearTimeout(timer);
        } else {
            setMessage('');
        }
    }, [step, currentWord]);

    return (
        <div style={{
            backgroundColor: config.backgroundColor,
            height: '100vh',
            overflow: 'hidden',
            position: 'relative',
            fontFamily: "'Autour One', cursive"
        }}>
            <Header
                color={config.headerColor}
                enableText={enableText}
                setEnableText={setEnableText}
                enableAudio={enableAudio}
                setEnableAudio={setEnableAudio}
            />
            <StarBackground imagePath={config.planetBackground} />
            <Planet image={config.planetImage} />

            {enableText && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    opacity: 0.9,
                    color: 'black',
                    padding: '1rem 2rem',
                    borderRadius: '12px',
                    fontSize: 'clamp(24px, 6vw, 48px)',
                    fontWeight: 'bold',
                    maxWidth: '90vw',
                    whiteSpace: 'nowrap'
                }}>
                    {currentWord}
                </div>
            )}
            <Controls
                colors={config.controlColors}
                onRepeat={() => console.log('Repeat')}
                onRecord={() => console.log('Record')}
                onValidate={() => {
                    setStep(4);
                    if (onValidate) onValidate();
                }}
                onPlay={() => {
                    const audio = document.querySelector('audio');
                    if (!audio) {
                        console.warn('Audio element not found');
                        setTimeout(() => setStep(2), 2000);
                        return;
                    }
                    audio.addEventListener('ended', () => {
                        setStep(2);
                    }, { once: true });
                }}
                context={'1'} //Sostituire con tutorial
                recording={isRecording}
                disableUpload={true}
            />

            <Character name="Mars" position='left' isActive={true} />
            {enableText && <div className="bubble">{message}</div>}

            <Character
                name={config.character}
                position='right'
                isActive={false}
            />

            <Planet image={config.planetImage} />
        </div>
    );
}
